import React, { useEffect, useState } from 'react';


const New1 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
     <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">NEWS</h1>
      <h1 className="text-[15px] md:text-[32px] font-bold mb-4 text-black">Agri-Tech , The future of Agriculture.</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744560910/image-1_kzlqxy.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
          
        </div>
      </div>

     
    <div className='px-1'>
      {/* Content Section */}
      <div className="mt-5 max-w-screen-xl w-full">
        <h3 className="text-black font-normal text-[14px] md:text-[30px]">March 03, 2025</h3>
        <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
          <p>Story by Editorial team</p>
          <div className="flex items-center gap-2 text-[#155528]">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
              alt="Clock"
              className="h-6 w-6 md:h-8 md:w-8"
            />
            <p>2 Minutes read</p>
          </div>
        </div>
      </div>

    
      {/* Main Text Section */}
      <div className="mt-5 space-y-10">
  <p className="text-[10px] md:text-[32px] text-black font-normal">
    <strong>Urban Farming in Namibia</strong><br/>
    Urban farming in Namibia is gaining momentum as a sustainable solution to food insecurity, particularly in rapidly growing cities like Windhoek and Swakopmund. These initiatives not only enhance food access but also promote community empowerment and environmental sustainability.
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal">
    <strong>Key Urban Farming Projects in Namibia</strong><br/>
    <strong>Swakopmund Urban Agriculture Project:</strong> Initiated in 2020 at a former sewage plant, this project started with 30 participants and has since expanded to accommodate more community members. Supported by the UNDP's Build Back Better programme, it focuses on producing nutritious vegetables such as cucumbers, beetroot, tomatoes, and green peppers. The produce is sold locally, contributing to food security and providing income opportunities for participants.<br/><br/>
    <strong>Farm Okukuna in Windhoek:</strong> Established in 2017, Farm Okukuna offers land and training to disadvantaged citizens, including informal vendors and the homeless, enabling them to produce vegetables and other farm products. Beneficiaries receive training in land preparation, fertilizers, and farming implements, empowering them to combat hunger and improve their livelihoods.<br/><br/>
    <strong>Urban Harvest:</strong> This initiative focuses on transforming underutilized city spaces into thriving green areas using hydroponic technology. By growing fresh, organic produce locally, Urban Harvest aims to reduce carbon footprints and create green spaces that encourage community interaction.
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal">
    <strong>Government Support and Sustainability</strong><br/>
    The Ministry of Agriculture, Water and Land Reform (MAWLR) has launched the <strong>"Integrated Initiative in Support of Urban and Peri-Urban Horticulture Development"</strong> project. This initiative aims to improve food security by providing access to <strong>high-quality fresh produce year-round, promoting employment, and supporting disadvantaged</strong> groups. Technologies such as micro-gardens, micro-irrigation, and integrated production and protection management techniques are employed to ensure sustainable urban farming practices.
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal">
    Urban farming in Namibia is not just about growing food; it's about <strong>cultivating resilience, fostering community, and ensuring a sustainable future.</strong> Through collaborative efforts between local governments, international organizations, and communities, urban agriculture is transforming cities into hubs of innovation and self-reliance.
  </p>

  <div className='md:h-10 h-4'></div>
</div>

    </div>

    </div>
   </div>
  );
};

export default New1;
